import React from 'react';
import DrawerAnchor from '../../UI/DrawerAnchor';
import ListAssign from './ListAssign/ListAssign';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import TitleDataStore from '../../Title/containers/TitleDataStore';

export class ListAssignDrawer extends React.Component {
	render() {
		const isMobile = this.props.isMobile();
		return (
			<DrawerAnchor
				closable={true}
				width={isMobile ? '100%' : '700px'}
				placement={isMobile ? 'bottom' : 'left'}
				height={isMobile ? '90%' : '100%'}
				renderDrawerContent={this.renderDrawerContent}>
				{this.props.children}
			</DrawerAnchor>
		);
	}

	renderDrawerContent = drawer => {
		return drawer.isVisible && this.renderCollaborativeLists();
	};

	renderCollaborativeLists = () => {
		const { skus } = this.props;
		if (skus?.length === 1) {
			return (
				<TitleDataStore sku={skus[0]}>
					<ListAssign skus={skus} />
				</TitleDataStore>
			);
		}
		return <ListAssign skus={skus} />;
	};
}

export default withIsMobile(ListAssignDrawer);
